<template>
  <section>
    <q-table
      style="height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      class="q-mt-md tabela-tamanho-fixo"
      row-key="name"
      color="primary"
      :pagination="pagination"
      dense
      :rows-per-page-label="'Linhas Por Página'"
      :rows-per-page-options="[10, 25, 50, 100]"
      :filter="filtrar"
    >
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-remover="props">
        <q-td>
          <q-btn
            color="negative"
            icon="delete"
            dense
            round
            @click="removerFerramenta(props.row.ferramenta_uuid)"
          />
        </q-td>
      </template>
    </q-table>
  </section>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
const columns = [
  {
    name: "nome_ferramenta",
    label: "Ferramenta",
    field: "nome_ferramenta",
    align: "left",
  },
  {
    name: "status_ferramenta",
    label: "Status Ferramenta",
    field: "status_ferramenta",
    align: "left",
  },
  {
    name: "nome_vendor",
    label: "Unidade",
    field: "nome_vendor",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];
export default {
  setup() {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
    });
    const rows = ref([]);
    const disable = ref(true);
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();

    const id = route.params.id;

    const getFerramentas = async (page = 0, rowsPerPage = 1000) => {
      disable.value = true;

      try {
        let response = await store.dispatch("user/getFerramentas", {
          id,
          page,
          per_page: rowsPerPage,
        });

        rows.value = response.data.result[0].ferramentas;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getFerramentas);

    const removerFerramenta = async (ferramenta_uuid) => {
      try {
        await store.dispatch("user/removerFerramenta", {
          id,
          ferramenta_uuid,
        });

        quasar.notify({
          message: "Grupo removido com sucesoo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFerramentas();
      } catch (error) {
        quasar.notify({
          message: "Erro ao remover grupo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      columns,
      rows,
      pagination,
      disable,
      getFerramentas,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      removerFerramenta,
      filtrar: ref(""),
    };
  },
};
</script>
